import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useAuthContext } from '../../context/auth';
import {
	RUN_AUTOFILL,
	RUN_AUTOFILL_CANCEL_BUTTON_TEXT,
	RUN_AUTOFILL_CONFIRMATION_BODY,
	RUN_AUTOFILL_CONFIRMATION_TITLE,
} from '../../data/labelsAndMessages';
import { AUTOFILL_ALWAYS_ON_FF } from '../dashboard/constants';
import DefaultDialog from '../DefaultDialog';

interface Props {
	onConfirm: () => void;
	disabled: boolean;
}

const RunAutofillButtonAndModal = (props: Props) => {
	const { onConfirm, disabled } = props;
	const authData = useAuthContext();
	const { configProperties } = authData.auth;
	const autofillButtonAlwaysEnabled = configProperties[AUTOFILL_ALWAYS_ON_FF];

	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	const open = () => setIsOpen(true);
	const onConfirmClick = () => {
		close();
		onConfirm();
	};

	const isButtonDisabled = autofillButtonAlwaysEnabled ? false : disabled;

	return (
		<>
			<Button
				color='secondary'
				variant='outlined'
				disabled={isButtonDisabled}
				onClick={open}
			>
				{RUN_AUTOFILL()}
			</Button>
			<DefaultDialog
				actions={[
					{ text: RUN_AUTOFILL(), onClick: onConfirmClick },
					{ text: RUN_AUTOFILL_CANCEL_BUTTON_TEXT(), onClick: close },
				]}
				open={isOpen}
				onClose={close}
				title={RUN_AUTOFILL_CONFIRMATION_TITLE()}
			>
				{RUN_AUTOFILL_CONFIRMATION_BODY()}
			</DefaultDialog>
		</>
	);
};

export default RunAutofillButtonAndModal;
